export enum SiteType {
  DEFAULT = 'DEFAULT',
  REMOTE = 'REMOTE',
  UNANNOUNCED = 'UNANNOUNCED',
}
